<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="400px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span> Make a withdraw</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container>
        <custom-form
          :fields="paymentType"
          :method="method"
          :action="url"
          @submitted="$emit('changed', $event)"
          @input:amount_without_fees_in_euro="updateFees"
        >
          <v-container>
            <v-row no-gutters>
              <v-col cols="12">
                <custom-user-search
                  name="user_id"
                  label="Select the customer"
                  item_name="full_name"
                  item_value="id"
                  icon="mdi-account-search"
                  @changed="updateBankAccounts"
                />
                <div class="mb-6">
                  <span v-if="selected_user"
                    >Balance : €{{ selected_user.client.euro_balance }}</span
                  >
                </div>
              </v-col>
              <v-col cols="12">
                <custom-select
                  ref="cashInMethod"
                  name="cashout_method_id"
                  :items="cashout_methods"
                  @changed="handleCashoutMethods"
                  label="Select the cashout method"
                />
              </v-col>
              <v-col cols="12">
                <custom-input name="amount_without_fees_in_euro" label="Amount(Euro)" />
              </v-col>

              <v-col
                cols="12"
                v-if="cashoutType == 'bank_transfer' || cashoutType == 'manual_bank_transfer'"
              >
                <custom-select
                  name="bank_account_id"
                  :items="bank_accounts"
                  item-value="id"
                  item-text="title"
                  label="Select the user Bank Account"
                />
                <div class="mb-6">
                  <span>Fees : €{{ fee }}</span>
                </div>
              </v-col>
              <v-col cols="12">
                <custom-select
                  ref="preferredChannel"
                  name="preferred_channel"
                  :items="['email', 'sms']"
                  label="Prefered Notification Channel"
                />
              </v-col>
              <v-col cols="12" v-if="cashoutType == 'mobile_money'">
                <custom-select
                  name="mobile_money_account_id"
                  :items="mobile_accounts"
                  item-value="id"
                  item-text="title"
                  label="Select the Mobile Money Account"
                />
                <div class="mb-6">
                  <span>Fees : €{{ fee }}</span>
                </div>
              </v-col>
              <v-col cols="12">
                <custom-button block color="primary"> Confirm </custom-button>
              </v-col>
            </v-row>
          </v-container>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    method: { default: "post", type: String },
    paymentType: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      selected_cashout_method_id: null,
      fee: 0,
      selected_user: null,
      cashoutType: null,
      cashout_methods_data: [],
      cached_bank_accounts: [],
      bank_accounts: [],
      mobile_accounts: [],
      key: 1,
    };
  },
  computed: {
    url() {
      return "api/v1/initiatePayoutFromBackOffice";
    },
    cashout_methods() {
      return this.getSelectOptions(this.cashout_methods_data);
    },
  },
  async created() {
    await this.fetchData();
  },
  watch: {
    // isActive() {
    //   this.key++;
    // },
  },
  methods: {
    getSelectOptions(data) {
      return data.map(({ id, name }) => ({ value: id, text: name }));
    },
    handleCashoutMethods(value) {
      this.$http.get(`/api/v1/transactions/transferCashoutMethods/${value}`).then((response) => {
        this.cashoutType = response.payment_type.name;
        this.selected_cashout_method_id = response.id;
      });
    },
    async updateBankAccounts(user_id) {
      await this.$http.get(`/api/v1/users/${user_id}`).then((response) => {
        this.selected_user = response;
      });
      await this.$http.get(`/api/v1/userBankAccounts/all/${user_id}`).then((response) => {
        this.bank_accounts = response.data;
      });
      await this.$http.get(`/api/v1/userMMAccounts/all/${user_id}`).then((response) => {
        this.mobile_accounts = response.data;
      });
    },
    async updateFees(value) {
      await this.$http
        .post(`/api/v1/payments/getEuroAppliedFees/withdraw/${this.selected_user.id}`, {
          cashout_method_id: this.selected_cashout_method_id,
          euro_amount: value,
          country_id: this.selected_user.country_id,
        })
        .then((response) => {
          this.fee = response.fee;
        });
    },
    getUserOptions(data) {
      return data.map(({ id, full_name }) => ({ value: id, text: full_name }));
    },
    async fetchData() {
      await this.$http.get("/api/v1/transactions/transferCashoutMethods/all").then((response) => {
        this.cashout_methods_data = response;
      });
      await this.$http.get("/api/v1/userBankAccounts/all").then((response) => {
        this.cached_bank_accounts = response.data;
      });
    },
  },
};
</script>
